import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css'],
  standalone: false
})
export class SearchInputComponent {
  @Input() value: string = '';
  @Input() placeholder: string = 'Search';

  /** Fires on every keystroke/paste — same trigger data every grid search box already
   *  passes into its own filterData(value)/onSearch(value) method. */
  @Output() valueChange = new EventEmitter<string>();

  /** Fires only when the clear (×) button is clicked — kept separate from
   *  valueChange('') because several pages' clearList()/clearSearch() do more than
   *  reset the text (reset paging/sort, trigger a full reload, etc.). */
  @Output() cleared = new EventEmitter<void>();

  onInput(newValue: string): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  onClear(): void {
    this.value = '';
    this.cleared.emit();
  }
}
